<template>

  <t-page>

    <t-dialog-ordained @hidden="getPage"
                       primary-key-column="typeEvidenceStatusId"
                       foreign-key-column="onlaineId"
                       v-if="modalOrdained"
                       :path="currentPage.path"
    />
    
    <t-page-list :title="t('list-of') + currentPage.pageTitle" :user-auth="userAuth"
                 :total-pages="request.totalPages" :total-elements="request.totalElements" @getPage="getPage"
                 :breadcrumb="breadcrumb">

      <template #search>

        <t-button v-if="userAuth.validation.validationCreate" :text="t('insert') + ' ' + currentPage.singularTitle" :to="currentPage.name + '-form-new'"
                  primary/>

        <t-button v-if="userAuth.validation.validationCreate || userAuth.validation.validationUpdate" :text="'Alterar Ordem'"
                  @click="openDialogOrdained()" />

        <t-content-header-search-default @searchChange="searchDefault"
                                         @onClearSearch="clearSearch()"
                                         :fields-custom="entityFieldCustomized('page')"
                                         :filtered-default="filteredDefault" :filtered-advanced="filteredAdvanced"
                                         :search-form="form" />
      </template>


      <t-table :show="checkViewListTableDefault()" @reload="reloadPageList()"
               :filtered="checkIsFiltered()"
               :busy="!pageListIsLoaded"
               :items="request.content"
               :user-auth="userAuth"
               :fields="fields"
               primary-key-column="typeEvidenceStatusNumber" link-primary-column="name"/>

    </t-page-list>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageListMixin from "@/mixins/page/pageListMixin"
import TDialogOrdained from "@/components/template/dialog/t-dialog-ordained.vue";

export default {
  components: {TDialogOrdained},
  mixins: [pageDefaultMixin, pageListMixin],
  name: 'TypeEvidenceStatus',
  data() {
    return {
      enableGeneralFields: false,
      fields: [
        {key: "name", label: "Status Evolução"},
        {key: "textColor", label: "Cor do Texto", formatter: "color"},
        {key: "backgroundColor", label: "Cor do Fundo", formatter: "color"},
        {key: "note", label: "Obs."},
        {key: "status", label: "Status"},
      ],
      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela

      //--------------------------------------------------------------------------------------
    }
  },
  methods: {

    mountedPrepare() {

      this.breadcrumb = [
        {text: 'Configurações', to: {name: 'checklist-setting'}},
      ]

    },
    async mountedContinued() {


    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedList()

    await this.mountedContinued()

  },
}
</script>

